import AppMenuBurger from '@/components/AppMenu/AppMenuBurger';
import AppMenubarItem from '@/components/AppMenu/AppMenubarItem';
import AskForStatsBtn from '@/components/header/AskForStatsBtn';
import { useGetMenuNavigationsQuery } from '@/features/api/endpoints/menuNavigationEndpoints';
import { useUserPermissions } from '@/shared/auth/useUserAffectations';
import { Box, Group, Skeleton } from '@mantine/core';

// Largeurs variées pour imiter des libellés de menu pendant le chargement
const SKELETON_WIDTHS = [90, 110, 70, 140, 90, 100];

const AppMenuBar = () => {
  // Les entrées sont filtrées par permission : on attend aussi les permissions
  const { isLoading: isPermissionsLoading } = useUserPermissions();
  const { data: menuNavigations = [], isLoading: isMenuLoading } = useGetMenuNavigationsQuery({
    fields: [
      '*',
      {
        children: [
          '*',
          {
            children: [
              '*',
              {
                children: [
                  '*',
                  {
                    children: ['*'],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    filter: {
      parent: {
        _null: true,
      },
      status: {
        _eq: 'published',
      },
    },
  });

  const isLoading = isMenuLoading || isPermissionsLoading;

  return (
    <Box
      bg="white"
      px="xs"
      h="40px"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 'var(--mantine-spacing-md)',
      }}
    >
      {/* Barre horizontale à partir de md, menu burger en dessous */}
      <Group h="100%" gap={isLoading ? 'md' : 0} wrap="nowrap" visibleFrom="md">
        {isLoading
          ? SKELETON_WIDTHS.map((width, index) => (
              <Skeleton key={index} h={16} w={width} radius="sm" />
            ))
          : menuNavigations.map(menuNavigation => (
              <AppMenubarItem key={menuNavigation.id} item={menuNavigation} />
            ))}
      </Group>
      <Box hiddenFrom="md">
        {isLoading ? (
          <Skeleton h={24} w={24} radius="sm" />
        ) : (
          <AppMenuBurger items={menuNavigations} />
        )}
      </Box>
      <Box style={{ flexShrink: 0 }}>
        <AskForStatsBtn />
      </Box>
    </Box>
  );
};

export default AppMenuBar;
